export default {
  data () {
    return {
      wakeLock: null,
      keepAwakeVideo: null,
      visibilityHandler: null
    }
  },
  methods: {
    // 啟用防休眠（支援 Android Chrome 與 iOS Safari）
    async enableKeepAwake () {
      try {
        if ('wakeLock' in navigator) {
          // ✅ Android / Chrome: 綁定 visibilitychange，確保切換分頁回來時自動重啟防休眠
          if (!this.visibilityHandler) {
            this.visibilityHandler = async () => {
              if (this.wakeLock !== null && document.visibilityState === 'visible') {
                 this.requestWakeLock()
              }
            }
            document.addEventListener('visibilitychange', this.visibilityHandler)
          }
          
          await this.requestWakeLock()
        } else {
          // ⚠️ Safari 不支援 Wake Lock，啟用 iOS 備案
          this.enableKeepAwakeIOS()
        }
      } catch (err) {
        console.warn('⚠️ 進入 iOS Fallback:', err)
        this.enableKeepAwakeIOS()
      }
    },

    // 專屬申請 WakeLock 的方法
    async requestWakeLock () {
      // 關鍵防護：必須要在網頁「可見」的狀態下才能申請，否則會報錯
      if (document.visibilityState !== 'visible') return
      
      try {
        this.wakeLock = await navigator.wakeLock.request('screen')
        console.log('🔒 螢幕保持喚醒中 (Wake Lock 啟用)')
        
        this.wakeLock.addEventListener('release', () => {
          console.log('🔓 Wake Lock 已釋放 (可能因視窗被縮小)')
        })
      } catch (err) {
        console.warn('⚠️ Wake Lock 申請被拒:', err)
      }
    },

    // 關閉防休眠
    async disableKeepAwake () {
      // 清除可見度監聽器
      if (this.visibilityHandler) {
        document.removeEventListener('visibilitychange', this.visibilityHandler)
        this.visibilityHandler = null
      }

      // 釋放 Chrome WakeLock
      if (this.wakeLock) {
        try {
          await this.wakeLock.release()
          console.log('🔓 Wake Lock 已手動解除')
        } catch (err) {}
        this.wakeLock = null
      }

      // 釋放 iOS 影片
      if (this.keepAwakeVideo) {
        this.keepAwakeVideo.pause()
        this.keepAwakeVideo.removeAttribute('src') // 徹底清空 src 避免殘留錯誤
        this.keepAwakeVideo.load()
        this.keepAwakeVideo.remove()
        this.keepAwakeVideo = null
        console.log('🛑 iOS 防休眠影片已移除')
      }
    },

    // iOS Safari 防鎖屏替代法：播放隱藏靜音影片
    enableKeepAwakeIOS () {
      if (this.keepAwakeVideo) return

      // ✅ 使用合法且極小的空白 MP4 Base64 (NoSleep.js 同款)
      const video = document.createElement('video')
      video.setAttribute('playsinline', '')
      video.src = 'data:video/mp4;base64,AAAAIGZ0eXBpc29tAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAAAAxtZGF0AAAAAAABAHBtb292AAAAbG12aGQAAAB8JbEAAHwlsQAAAH0AAAEAAAEAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAB0cmFrAAAAXHRraGQAAAADfCWxAAB8JbEAAAABAAAAAAABAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAEAAQAAAAAAALBWRCAAAABQZWR0cwAAACBlbHN0AAAAAAAAAAEAAAEAAAAAAQAAAAAABWhNRElBAAAAHG1kaGQAAAB8JbEAAHwlsQAAAH0AAAEAAABWAAAAAABHaGRscgAAAAAAAAAAdmlkZQAAAAAAAAAAAAAAAAAAAABWaW5mbwAAABR2bWhkAAAAAQAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAADRzdGJsAAAALHN0c2QAAAAAAAAAAQAAABxhdmMxAAAAAAAAAAEAAQAAAAAAAAAAAAAAAAAAAAAAAABzdHRzAAAAAAAAAAEAAAABAAABAAAAABxzdHNjAAAAAAAAAAEAAAABAAAAAQAAAAEAAAAcc3RzejAAAAAAAAAAAAAAAQAAJwAAAAAQU1RDTwAAAAAAAAABAAAAqw=='
      video.loop = true
      video.muted = true
      video.style.display = 'none'

      document.body.appendChild(video)
      
      const playVideo = () => {
        if (!this.keepAwakeVideo) return
        video.play().then(() => {
          console.log('📱 iOS 防休眠影片啟用成功')
        }).catch(err => {
          // iOS 規定有時還是需要手勢才能播放
          console.warn('iOS 防休眠影片需等待手勢觸發:', err.name)
        })
      }

      // 嘗試自動播放
      playVideo()

      // 加買雙重保險：如果在沒有手勢的情況下被阻擋，等使用者一碰到螢幕就立刻解鎖
      const unlockVideo = () => {
        playVideo()
        document.removeEventListener('touchstart', unlockVideo)
        document.removeEventListener('click', unlockVideo)
      }
      document.addEventListener('touchstart', unlockVideo, { once: true })
      document.addEventListener('click', unlockVideo, { once: true })

      this.keepAwakeVideo = video
    },

    // 解鎖 AudioContext (保持原樣即可)
    keepAudioOpen () {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext
      this.ctx = new AudioContextClass()

      const unlockAudio = () => {
        if (this.ctx && this.ctx.state === 'suspended') {
          this.ctx.resume().then(() => {
            console.log('[AudioContext 解鎖成功]')
          })
        }

        const silentAudio = new Audio()
        silentAudio.src = "data:audio/mp3;base64,//uQxAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCA"
        silentAudio.play().catch(() => {}) 

        document.removeEventListener('touchstart', unlockAudio)
        document.removeEventListener('click', unlockAudio)
      }

      document.addEventListener('touchstart', unlockAudio, { once: true })
      document.addEventListener('click', unlockAudio, { once: true })
    }
  },

  beforeDestroy () {
    this.disableKeepAwake()
  }
}